import en from './en';
import cn from './zh-Hans';

export const localeTextMap = {
    en,
    cn,
};

export type LocaleCode = keyof typeof localeTextMap;
export type LocaleText = (typeof localeTextMap)['cn'];

export const SUPPORT_LOCALES = Object.keys(localeTextMap);
